/**
 * @generated SignedSource<<33d56a90134995b7090df082dc6f3812>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderItemInlineFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  readonly quantity: number;
  readonly price: number;
  readonly discount: number;
  readonly currencyCode: string;
  readonly meta: any | null;
  readonly product: {
    readonly " $fragmentSpreads": FragmentRefs<"productFragment">;
  } | null;
  readonly " $fragmentType": "salesOrderItemInlineFragment";
};
export type salesOrderItemInlineFragment$key = {
  readonly " $data"?: salesOrderItemInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderItemInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "salesOrderItemInlineFragment"
};

(node as any).hash = "7ec875699cf6055a6da1b7f260babd4d";

export default node;
